import { LruCache } from '@zwaarcontrast/ol-graticule';
// Slack so a viewport edge sitting exactly on a cached window edge still counts
// as covered (floating-point equality guard).
const COVER_EPS = 1e-6;
/**
 * Per-line cache of transformed polylines, keyed `${axis}${gridValue}`, bounded
 * by an LRU so a long pan across many lines cannot grow it without limit. Stores
 * view-projection coordinates, so it is cleared when the view projection changes.
 */
export class LineTransformCache {
    cache_;
    projKey_ = '';
    constructor(max = 1024) {
        this.cache_ = new LruCache(max);
    }
    /** Drop everything if the view projection changed (cached coords are in it). */
    ensureProjection(projKey) {
        if (projKey !== this.projKey_) {
            this.cache_.clear();
            this.projKey_ = projKey;
        }
    }
    /**
     * The cached polyline for this line IF it is sampled for `band` and its window
     * still covers `[vMin, vMax]`; otherwise undefined (caller recomputes + sets).
     */
    get(key, band, vMin, vMax) {
        const entry = this.cache_.get(key);
        if (entry !== undefined &&
            entry.band === band &&
            entry.pMin <= vMin + COVER_EPS &&
            entry.pMax >= vMax - COVER_EPS) {
            return entry;
        }
        return undefined;
    }
    set(key, entry) {
        this.cache_.set(key, entry);
    }
    clear() {
        this.cache_.clear();
    }
    get size() {
        return this.cache_.size;
    }
}
//# sourceMappingURL=lineTransformCache.js.map